<div class="db-template">

  <div>
    <div class="ds-notification mb21">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p>
          <span [innerHTML]="'text_websiteCustomizerNotification'|dbText"></span>
        </p>
      </div>
    </div>

    <section class="website-customizer-container"
             [ngClass]="theme"
             [ngStyle]="styles">
      <div class="website-customizer-body-container">
        <div class="website-customizer-body">
          <div class="website-customizer-image-section mb25">
            <div class="section-image-container">
              <img src="assets/images/builder-v2/empty-img.svg" alt="empty-img"/>
            </div>
            <div class="section-main-container">
              <div class="subtitle">Overline</div>
              <div class="title">See how our<br/> display text<br/> enhances appeal.</div>
              <div class="description">This is a clear example of body large<br/> text, showcasing its
                readability and<br/> impact on visual hierarchy.
              </div>
              <div class="actions">
                <button class="main-btn">Button</button>
                <button class="secondary-btn">Button</button>
              </div>
            </div>
          </div>
          <div class="website-customizer-card-section mb60">
            <div class="section-action-container">
              <div class="section-action-user-container">
                <div class="user-avatar-container">
                </div>
                <div class="user-info-container">
                  <div>Name Surname</div>
                  <div>&#64;username</div>
                </div>
              </div>
              <div class="section-description-container mt20 mb20">
                This is a detailed example of review text, highlighting its clarity and<br/> effectiveness in providing
                comprehensive feedback. It ensures that all<br/> aspects are covered, making it easier for readers
                to understand and
              </div>
              <div class="section-actions-container">
                <div>
                  <i class="db-icon db-icon-back"></i>
                </div>
                <div>
                  <i class="db-icon db-icon-back2"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="website-customizer-contact-section">
            <div class="section-contact-container">
              <div class="section-contact-header-container">
                Contact us
              </div>
              <div class="contact-input-container mb20">
                <label class="input-label mb10">Email</label>
                <input placeholder="Placeholder">
              </div>
              <div class="contact-input-container mb24">
                <label class="input-label mb10">Message</label>
                <input placeholder="Placeholder">
              </div>
              <div class="contact-checkbox">
                <input type="checkbox"
                       checked
                       class="custom-checkbox"
                       id="contact-check">
                <label for="contact-check" class="ds-checkbox-label green">
                  <span>I accept the <strong>Terms</strong></span>
                </label>
              </div>
              <button class="main-btn">Button</button>
            </div>
            <div class="section-contact-image-container">
              <img src="assets/images/builder-v2/empty-img.svg" alt="empty-img"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

</div>


<div class="db-design">
  <div class="title mb8">{{ 'text_questionTourStepTwoTitle' | dbText}}</div>
  <div class="description mb30" [innerHTML]="'text_playWithFonts' | dbText"></div>

  <!-- Color Options -->
  <div class="color-picker-container mb24">
    <span class="title-small mb6">{{ 'text_colors' | dbText}}</span>
    <div class="db-list">

      <div *ngFor="let color of switchers[2].optionsList"
           (click)="selectOption(color)"
           class="color-item {{color.title}} {{switchers[2].defaultSelected}}"
           [class.selected]="(color.title === (selectedColor?.title || switchers[2].defaultSelected.title))">
        <div class="color-set-container">
          <div class="color" [style.background-color]="color.primaryColor"></div>
          <div class="color" [style.background-color]="color.secondaryColor"></div>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="font-picker-container mb30">
    <div class="header mb6">
      <span class="title-small">Fonts</span>
      <img src="assets/images/builder-v2/google_font.svg"
           alt="google-font"/></div>

    <ds-dropdown [dsDropdownOptions]="optionsFontList || switchers[1].optionsList"
                 [value]="selectedOption || switchers[1].defaultSelected.value"
                 [customFontFamily]="true"
                 [dsDropdownSearch]="true"
                 [showDropDown]="false"
                 [dsDropdownWithSearchIcon]="false"
                 [dsDropdownPlaceHolder]="this.switchers[1].defaultSelected.value"
                 (searchOutside)="searchOptions($event)"
                 [dsDropdownListMaxHeight]="'211px'"
                 (click)="resetDropdownOptions()"
                 (onOptionChoose)="selectOption($event)">
    </ds-dropdown>
  </div>-->

  <div class="style-picker-container">
    <span class="title-small mb10">{{ 'text_managerThemesShort' | dbText }}</span>

    <div class="db-styles mt10">
      <div class="db-style {{theme?.class}}" *ngFor="let theme of switchers[0].optionsList"
           (click)="selectOption(theme)"
           [class.selected]="(theme?.title === (selectedTheme?.title || switchers[0]?.defaultSelected?.title))">
        <div>
          <span class="theme-title">{{ theme?.title | dbText }}</span>
          <span class="theme-paragraph">{{ 'text_thisIsYourParagraph' | dbText}}</span>
        </div>
        <a class="theme-btn {{theme?.class}}">
          <span [innerHTML]="'Button'"></span>
        </a>
      </div>
    </div>
  </div>

</div>
<div class="cover"
     *ngIf="(builderInteractionsService.buildLoading|async) && !popupMode && !vibeCodingFlow">
</div>
